module.exports = __webpack_public_path__ + "img/t1.d2acee47.png";